// app/javascript/controllers/rental_availability_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["startDate", "endDate", "guestCount"]

  connect() {
    console.log("Rental Availability controller connected")
  }

  checkAvailability() {
    const startDate = this.startDateTarget.value
    const endDate = this.endDateTarget.value
    const guestCount = this.guestCountTarget.value

    if (!startDate || !endDate || !guestCount) return

    const url = `${this.element.dataset.rentalPath}/check_availability`
    const params = new URLSearchParams({
      start_date: startDate,
      end_date: endDate,
      guest_count: guestCount
    })

    fetch(`${url}?${params}`, {
      headers: {
        "Accept": "text/vnd.turbo-stream.html"
      }
    })
    .then(response => {
      if (!response.ok) throw new Error('Network response was not ok')
      return response.text()
    })
    .then(html => {
      Turbo.renderStreamMessage(html)
    })
    .catch(error => {
      console.error('Error:', error)
    })
  }
}